<template>
    <div class="info-list">
        <Header/>
        <div class="blank20"/>
        <div class="main-page-content contain-left-right">
            <LeftContent :type="type" @changeType="changeType"/>
            <RightContent />
        </div>
        <div class="blank20"/>
        <Footer/>
    </div>
</template>
<script>
import LeftContent from './components/leftContent';
export default {
    data() {
        return {
            type:1,
        }
    },
    components:{
        LeftContent,
    },
    beforeMount() {
        this.$store.dispatch('UPDATE_RICHCONTENT', this.$http);
        if(this.$route.query.type){
            this.type = Number(this.$route.query.type);
        }
    },
    methods: {
        changeType(val){
            this.type = Number(val);
            this.$forceUpdate();
        }
    },
}
</script>
<style lang="scss" scoped>

</style>
